import {
    reducer as sharedReducer,
    selectors as sharedSelectors,
} from '../shared/instructionReducer';
import { FETCH_READING_OBSERVATIONS } from '../../actionTypes/reading/apiActionTypes';
import { parseObservations } from '../shared/instructionReducerParsers';

export const initialState = {
    selectedInstructionDate: null,
    selectedInstructionGrade: null,
    checkPoints: {},
    areCheckPointsFetched: false,
    isCheckPointSaving: false,
    error: null,
    observations: [],
    areObservationsFetching: false,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_READING_OBSERVATIONS.D8:
        case FETCH_READING_OBSERVATIONS.DECODING:
            return {
                ...state,
                observations: [
                    ...state.observations,
                    ...parseObservations(action.response.observations),
                ],
            };
        default:
            return sharedReducer(state, action);
    }
};

export const selectors = {
    ...sharedSelectors,
};
